import { render, staticRenderFns } from "./Statistical.vue?vue&type=template&id=7a202733&scoped=true&"
import script from "./Statistical.vue?vue&type=script&lang=js&"
export * from "./Statistical.vue?vue&type=script&lang=js&"
import style0 from "./Statistical.vue?vue&type=style&index=0&id=7a202733&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a202733",
  null
  
)

export default component.exports